import util from './utils'
import { nativeBridge as nioJsBridge } from '@nio-wad/universal-bridge-h5/dist/nativeBridge'
import {DataTrack} from '@nio-fe/mall-app-common-tools'
import {BrandEnum, currentBrand, isAlps, isFyCN} from "@/utils/brandUtils";

// const isiOS = util.isIphone();

// const userInfo = nioJsBridge.getUserInfo() || {}
// const accountId = userInfo?.data?.account_id || ''


// DataTrack.init(false, util.getEnv() === 3, isiOS ? "iOS" : "Android", accountId , isAlps(), true, currentBrand() )
const sensors = DataTrack.sensors

const dataTrack = {

  trackInit() {
    const isiOS = util.isIphone();

    const userInfo = nioJsBridge.getUserInfo() || {}
    const accountId = userInfo.data.account_id || ''

    DataTrack.init(true, util.getEnv() === 3, isiOS ? "iOS" : "Android", accountId, isAlps(), true, isFyCN() ? "fyCn" : currentBrand())
},

  /**
   * 车服订单详情页_页面浏览_车服洗车页面浏览
   * @param cityId 城市ID
   * @param statusDesc 订单状态: (待支付,已取消,待使用,已退款,退款中,已完成)
   */
  trackOrderDetailPageView(cityId, statusDesc) {
    const common = {
      page: "车服订单详情页",
      city_id: cityId,
      order_status: statusDesc
    }
    switch (currentBrand()) {
      case BrandEnum.nio:
        common.requirement_id = 781
        common.track_sign = "aCar.b2920.pageview.FCWTView"
        common.track_code = "aCar.b2920.pageview.FCWTView"
        sensors.track("FCWTView", common)
        break
      case BrandEnum.alps:
        common.requirement_id = 1717
        common.track_sign = "aALPSCar.b4003.d4008.click.FCWTClick"
        common.track_code = "aALPSCar.b4003.d4008.click.FCWTClick"
        sensors.track("FCWTView", common)
        break
      case BrandEnum.fy:
          common.requirement_id = 10850
          common.track_sign = "fyapp.b11932.c11944.pageview.FCWTView"
          common.track_code = "fyapp.b11932.c11944.pageview.FCWTView"
          sensors.track("FCWTView", common)
       break
    }
  },

  // 车服订单详情页-减免明细_点击_洗车页面点击
  trackOrderDetailPendingPayDiscountClick() {
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("FCWTClick", {
          requirement_id: 781,
          track_sign: "aCar.b2920.d2923.click.FCWTClick",
          track_code: "aCar.b2920.d2923.click.FCWTClick",
          page: "车服订单详情页",
          button_name: "减免明细查看",
          order_status: "待支付"
        })
        case BrandEnum.alps:
          sensors.track("FCWTClick", {
            requirement_id: 10846,
            track_sign: "aALPSCar.b4003.d4008.click.FCWTClick",
            track_code: "aALPSCar.b4003.d4008.click.FCWTClick",
            page: "车服订单详情页",
            button_name: "减免明细查看",
            order_status: "待支付"
          })
          break
        case BrandEnum.fy:
          sensors.track("FCWTClick", {
            requirement_id: 10850,
            track_sign: "fyapp.b11932.c11933.d11934.click.FCWTClick",
            track_code: "fyapp.b11932.c11933.d11934.click.FCWTClick",
            page: "车服订单详情页",
            button_name: "减免明细查看",
            order_status: "待支付"
          })
    
        break
    }
  },

  /**
   * 车服提交订单页_页面浏览_车服洗车页面浏览
   * @param cityId 城市ID
   * @param pageSource 页面来源: (车服商户详情页,车服商品详情页)
   */
  trackOrderConfirmPageView(cityId, pageSource) {
    const common = {
      page: "车服提交订单页",
      city_id: cityId,
    }
    switch (currentBrand()) {
      case BrandEnum.nio:
        common.requirement_id = 781
        common.track_sign = "aCar.b2918.pageview.FCWTView"
        common.track_code = "aCar.b2918.pageview.FCWTView"
        common.page_source = pageSource
        sensors.track("FCWTView", common)
        break
      case BrandEnum.alps:
        common.requirement_id = 10846
        common.track_sign = "aALPSCar.b4005.pageview.FCWTView"
        common.track_code = "aALPSCar.b4005.pageview.FCWTView"
        sensors.track("FCWTView", common)
        break
     case BrandEnum.fy:
          common.requirement_id = 10850
          common.track_sign = "fyapp.b11932.c11943.pageview.FCWTView"
          common.track_code = "fyapp.b11932.c11943.pageview.FCWTView"
          sensors.track("FCWTView", common)
          break
    }
  },

  // 车服提交订单页-优惠明细_点击_洗车页面点击
  trackOrderConfirmDiscountClick() {
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("FCWTClick", {
          requirement_id: 781,
          track_sign: "aCar.b2918.d2919.click.FCWTClick",
          track_code: "aCar.b2918.d2919.click.FCWTClick",
          page: "车服提交订单页",
          button_name: "优惠明细查看"
        })
        break
    }
  },

  /**
   * 车服服务说明_页面浏览_车服洗车页面浏览
   * @param cityId 城市ID
   */
  trackServiceDescPageView(cityId) {
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("FCWTView", {
          requirement_id: 781,
          track_sign: "aCar.b2913.pageview.FCWTView",
          track_code: "aCar.b2913.pageview.FCWTView",
          page: "车服服务说明",
          city_id: cityId
        })
        break
    }
  },

  /**
   * 车服商品详情页_页面浏览_车服洗车页面浏览
   * @param cityId 城市ID
   * @param shopId 店铺ID
   * @param servicePackageType 车辆服务权益类型：有包，无包
   * @param vehicleId 车辆id
   * @param modelType 车型
   * @param spuCode 商品ID
   * @param skuCode 子品ID
   * @param pageSource 页面来源: (车服商户详情页,车服首页,车服搜索页,洗车地图列表页)
   */
  trackGoodsDetailPageView(cityId, shopId, servicePackageType, vehicleId, modelType, spuCode, skuCode, pageSource) {
    const common = {
      page:"车服商品详情页",
      city_id: cityId,
      shop_id: shopId,
      vehicle_service_package_type: servicePackageType,
      vehicle_id: vehicleId,
      model_type: modelType,
      spu_code: spuCode,
      sku_code: skuCode,
      page_source: pageSource
    }
    switch (currentBrand()) {
      case BrandEnum.nio:
        common.requirement_id = 781
        common.track_sign = "aCar.b2904.pageview.FCWTView"
        common.track_code = "aCar.b2904.pageview.FCWTView"
        sensors.track("FCWTView", common)
        break
      case BrandEnum.alps:
        common.requirement_id = 10846
        common.track_sign = "aALPSCar.b4004.pageview.FCWTView"
        common.track_code = "aALPSCar.b4004.pageview.FCWTView"
        sensors.track("FCWTView", common)
        break
      case BrandEnum.fy:
          common.requirement_id = 10850
          common.track_sign = "fyapp.b11932.c11940.pageview.FCWTView"
          common.track_code = "fyapp.b11932.c11940.pageview.FCWTView"
          sensors.track("FCWTView", common)
          break
    }
  },

  /**
   * 车服商品详情页-商家联系方式_点击_洗车页面点击
   * @param spuCode 商品ID（与浏览埋点一致：standardCommodityNo）
   * @param skuCode 子品ID（与浏览埋点一致：commodity_no）
   */
  trackGoodsDetailDialClick(spuCode = '', skuCode = '') {
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("FCWTClick", {
          requirement_id: 781,
          track_sign: "aCar.b2904.d2916.click.FCWTClick",
          track_code: "aCar.b2904.d2916.click.FCWTClick",
          page: "车服商品详情页",
          button_name: "商家联系方式查看",
          spu_code: spuCode,
          sku_code: skuCode,
        })
        break
        case BrandEnum.alps:
          sensors.track("FCWTClick", {
            requirement_id: 10846,
            track_sign: "alps.b4004.c11929.click.FCWTClick",
            track_code: "alps.b4004.c11929.click.FCWTClick",
            page: "车服商品详情页",
            button_name: "商家联系方式查看",
            spu_code: spuCode,
            sku_code: skuCode,
          })
          break
        case BrandEnum.fy:
          sensors.track("FCWTClick", {
            requirement_id: 10850,
            track_sign: "fyapp.b11932.c11940.d11942.click.FCWTClick",
            track_code: "fyapp.b11932.c11940.d11942.click.FCWTClick",
            page: "车服商品详情页",
            button_name: "商家联系方式查看",
            spu_code: spuCode,
            sku_code: skuCode,
          })
          break
    }
  },

  /**
   * 车服商品详情页-优惠说明_点击_洗车页面点击
   * @param spuCode 商品ID（与浏览埋点一致：standardCommodityNo）
   * @param skuCode 子品ID（与浏览埋点一致：commodity_no）
   */
  trackGoodsDetailDiscountClick(spuCode = '', skuCode = '') {
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("FCWTClick", {
          requirement_id: 781,
          track_sign: "aCar.b2904.d2915.click.FCWTClick",
          track_code: "aCar.b2904.d2915.click.FCWTClick",
          page: "车服商品详情页",
          button_name: "优惠明细查看",
          spu_code: spuCode,
          sku_code: skuCode,
        })
        break
     case BrandEnum.alps:
          sensors.track("FCWTClick", {
            requirement_id: 10846,
            track_sign: "alps.b4004.c11926.click.FCWTClick",
            track_code: "alps.b4004.c11926.click.FCWTClick",
            page: "车服商品详情页",
            button_name: "优惠明细查看",
            spu_code: spuCode,
            sku_code: skuCode,
          })
          break
      case BrandEnum.fy:
        sensors.track("FCWTClick", {
          requirement_id: 10850,
          track_sign: "fyapp.b11932.c11940.d11941.click.FCWTClick",
          track_code: "fyapp.b11932.c11940.d11941.click.FCWTClick",
          page: "车服商品详情页",
          button_name: "优惠明细查看",
          spu_code: spuCode,
          sku_code: skuCode,
        })
        break
     
    }
  },

  /**
   * 车服搜索页_页面浏览_车服洗车页面浏览
   * @param cityId 城市ID
   * @param servicePackageType 车辆服务权益类型：有包，无包
   * @param vehicleId 车辆id
   * @param pageSource 页面来源, 目前为空字串，后续拓展可能使用
   * @param searchWord 搜索词
   */
  trackSearchPageView(cityId, servicePackageType, vehicleId, pageSource = "", searchWord = "") {
    console.log('trackSearchPageView==>',cityId, servicePackageType, vehicleId, pageSource, searchWord);
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("FCWTView", {
          requirement_id: 781,
          track_sign: "aCar.b2901.pageview.FCWTView",
          track_code: "aCar.b2901.pageview.FCWTView",
          page: "车服搜索页",
          city_id: cityId,
          vehicle_service_package_type: servicePackageType,
          vehicle_id: vehicleId,
          page_source: pageSource,
          search_word: searchWord,
        })
        break
      case BrandEnum.alps:
        sensors.track("FCWTView", {
          requirement_id: 1717,
          track_sign: "aALPSCar.b4007.pageview.FCWTView",
          track_code: "aALPSCar.b4007.pageview.FCWTView",
          page: "车服搜索页",
          city_id: cityId,
          search_word: searchWord,
        })
        break
       case BrandEnum.fy:
        sensors.track("FCWTView", {
          requirement_id: 10850,
          track_sign: "fyapp.b11932.c11935.pageview.FCWTView",
          track_code: "fyapp.b11932.c11935.pageview.FCWTView",
          page: "车服搜索页",
          city_id: cityId,
          search_word: searchWord,
        })
        break

    }
  },

  /**
   * 车服搜索页_结果_发起搜索请求
   * @param cityId 城市ID
   * @param isHotword 是否热门搜索词 BOOLEAN
   * @param isHistory 是否历史搜索词 BOOLEAN
   * @param searchWord 搜索词
   */
  trackSearchRequest(cityId, isHotword, isHistory, searchWord) {
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("SearchRequest", {
          requirement_id: 781,
          track_sign: "aCar.b2901.result.SearchRequest",
          track_code: "aCar.b2901.result.SearchRequest",
          page: "车服搜索页",
          city_id: cityId,
          is_hotword: isHotword,
          is_history: isHistory,
          search_word: searchWord
        })
        break
        case BrandEnum.alps:
        sensors.track("SearchRequest", {
          requirement_id: 10846,
          track_sign: "alps.b4007.click.SearchRequest",
          track_code: "alps.b4007.click.SearchRequest",
          page: "车服搜索页",
          city_id: cityId,
          is_hotword: isHotword,
          is_history: isHistory,
          search_word: searchWord
        })
        break
        case BrandEnum.fy:
        sensors.track("SearchRequest", {
          requirement_id: 10850,
          track_sign: "fyapp.b11932.c11935.d12110.click.SearchRequest",
          track_code: "fyapp.b11932.c11935.d12110.click.SearchRequest",
          page: "车服搜索页",
          city_id: cityId,
          is_hotword: isHotword,
          is_history: isHistory,
          search_word: searchWord
        })
        break
    }
  },

  /**
   * 车服首页_页面浏览_车服洗车页面浏览
   * @param cityId 城市ID
   * @param vehicleId 车辆id
   * @param modelType 车型
   * @param servicePackageType 车辆服务权益类型：有包，无包
   * @param grantType 权限类型
   * @param pageSource 页面来源: 全部服务页,搜索推荐,此刻,咨询,活动等
   */
  trackHomePageView(cityId, vehicleId, modelType, servicePackageType, grantType, pageSource) {
    console.log('trackHomePageView==>',cityId, vehicleId, modelType, servicePackageType, grantType, pageSource);
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("FCWTView", {
          requirement_id: 781,
          track_sign: "aCar.b2886.pageview.FCWTView",
          track_code: "aCar.b2886.pageview.FCWTView",
          page: "车服首页",
          city_id: cityId,
          vehicle_id: vehicleId,
          model_type: modelType,
          vehicle_service_package_type: servicePackageType,
          grant_type: grantType,
          page_source: pageSource
        })
        break
      case BrandEnum.alps:
        sensors.track("FCWTView", {
          requirement_id: 1717,
          track_sign: "aALPSCar.b4003.pageview.FCWTView",
          track_code: "aALPSCar.b4003.pageview.FCWTView",
          page: "车服首页",
          city_id: cityId,
          vehicle_id: vehicleId,
          model_type: modelType,
          page_source: pageSource
        })
        break
      case BrandEnum.fy:
        sensors.track("FCWTView", {
          requirement_id: 10850,
          track_sign: "fyapp.b11932.c11933.pageview.FCWTView",
          track_code: "fyapp.b11932.c11933.pageview.FCWTView",
          page: "车服首页",
          city_id: cityId,
          vehicle_id: vehicleId,
          model_type: modelType,
          page_source: pageSource
        })
        break
        return
    }
  },

  /**
   * 车服首页-商户推荐商品_点击_洗车页面点击
   * @param cityId 城市ID
   * @param shopId 店铺ID
   * @param spuCode 商品ID
   * @param skuCode 子品ID
   */
  trackHomeRecommendGoodsClick(cityId, shopId, spuCode, skuCode) {
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("FCWTClick", {
          requirement_id: 781,
          track_sign: "aCar.b2886.d2914.click.FCWTClick",
          track_code: "aCar.b2886.d2914.click.FCWTClick",
          page: "车服首页",
          module_name: "商户推荐商品",
          city_id: cityId,
          shop_id: shopId,
          spu_code: spuCode,
          sku_code: skuCode
        })
        break
     case BrandEnum.alps:
        sensors.track("FCWTClick", {
          requirement_id: 10846,
          track_sign: "alps.b4003.c11925.click.FCWTClick",
          track_code: "alps.b4003.c11925.click.FCWTClick",
          page: "车服首页",
          module_name: "商户推荐商品",
          city_id: cityId,
          shop_id: shopId,
          spu_code: spuCode,
          sku_code: skuCode
        })
        break
      case BrandEnum.fy:
        sensors.track("FCWTClick", {
          requirement_id: 10850,
          track_sign: "fyapp.b11932.c11933.d11936.click.FCWTClick",
          track_code: "fyapp.b11932.c11933.d11936.click.FCWTClick",
          page: "车服首页",
          module_name: "商户推荐商品",
          city_id: cityId,
          shop_id: shopId,
          spu_code: spuCode,
          sku_code: skuCode
        })
        break
      
    }
  },

  // 车服首页-订单历史_点击_洗车页面点击
  trackHomeHistoryMenuClick() {
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("FCWTClick", {
          requirement_id: 781,
          track_sign: "aCar.b2886.d2912.click.FCWTClick",
          track_code: "aCar.b2886.d2912.click.FCWTClick",
          page: "车服首页",
          button_name: "订单历史查看"
        })
        break
    }
  },

  // 车服首页-我的收藏_点击_洗车页面点击
  trackHomeMyFavoriteMenuClick() {
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("FCWTClick", {
          requirement_id: 781,
          track_sign: "aCar.b2886.d2911.click.FCWTClick",
          track_code: "aCar.b2886.d2911.click.FCWTClick",
          page: "车服首页",
          button_name: "我的收藏查看"
        })
        break
    }
  },

  /**
   * 车服首页-服务类目筛选_点击_洗车页面点击
   * @param cityId 城市ID
   * @param servicePackageType 车辆服务权益类型 (有包,无包)
   * @param tabName tab名称: 服务类目筛选项tab名称
   */
  trackHomeServicesTabClick(cityId, servicePackageType, tabName) {
    console.log('trackHomeServicesTabClick==>',cityId, servicePackageType, tabName);
    const common = {
      page: "车服首页",
      city_id: cityId,
      vehicle_service_package_type: servicePackageType,
      module_name: "服务类目筛选",
      tab_name: tabName
    }
    switch (currentBrand()) {
      case BrandEnum.nio:
        common.requirement_id = 781
        common.track_sign = "aCar.b2886.d2899.click.FCWTClick"
        common.track_code = "aCar.b2886.d2899.click.FCWTClick"
        sensors.track("FCWTClick", common)
        break
      case BrandEnum.alps:
        common.requirement_id = 10846
        common.track_sign = "aALPSCar.b4003.d4009.click.FCWTClick"
        common.track_code = "aALPSCar.b4003.d4009.click.FCWTClick"
        sensors.track("FCWTClick", common)
        break
      case BrandEnum.fy:
        common.requirement_id = 10850
        common.track_sign = "fyapp.b11932.c11933.d11939.click.FCWTClick"
        common.track_code = "fyapp.b11932.c11933.d11939.click.FCWTClick"
        sensors.track("FCWTClick", common)
        break
    }
  },

  /**
   * 车服首页-服务类目筛选_点击_洗车页面点击
   * @param cityId 城市ID
   * @param vehicleId 车辆id
   * @param servicePackageType 车辆服务权益类型 (有包,无包)
   * @param tabName tab名称: 运营筛选项tab名称
   */
  trackHomeFilterTabClick(cityId, vehicleId, servicePackageType, tabName) {
    // 公共参数
    const common = {
      page: "车服首页",
      city_id: cityId,
      vehicle_service_package_type: servicePackageType,
      module_name: "运营筛选位",
      tab_name: tabName,
      vehicle_id: vehicleId
    }
    switch (currentBrand()) {
      case BrandEnum.nio:
        common.requirement_id = 781
        common.track_sign = "aCar.b2886.d2898.click.FCWTClick"
        common.track_code = "aCar.b2886.d2898.click.FCWTClick"
        sensors.track("FCWTClick", common)
        break
      //这个点位没建
      case BrandEnum.alps:
        common.requirement_id = 10846
        common.track_sign = "aALPSCar.b4003.d4008.click.FCWTClick"
        common.track_code = "aALPSCar.b4003.d4008.click.FCWTClick"
        sensors.track("FCWTClick", common)
        break
      case BrandEnum.fy:
          common.requirement_id = 10850
          common.track_sign = "fyapp.b11932.c11933.d11938.click.FCWTClick"
          common.track_code = "fyapp.b11932.c11933.d11938.click.FCWTClick"
          sensors.track("FCWTClick", common)
          break
    }
  },

  // 车服首页-待核销券码快速展示_点击_洗车页面点击
  trackHomeQrCodeIconClick() {
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("FCWTClick", {
          requirement_id: 781,
          track_sign: "aCar.b2886.d2897.click.FCWTClick",
          track_code: "aCar.b2886.d2897.click.FCWTClick",
          page: "车服首页",
          button_name: "券码快速展示"
        })
        break
      case BrandEnum.alps:  
        sensors.track("FCWTClick", {
          requirement_id: 10846,
          track_sign: "alps.b4004.c11926.click.FCWTClick",
          track_code: "alps.b4004.c11926.click.FCWTClick",
          page: "车服首页",
          button_name: "券码快速展示"
        })
        break
      case BrandEnum.fy:
        sensors.track("FCWTClick", {
          requirement_id: 10850,
          track_sign: "fyapp.b11932.c11933.d11937.click.FCWTClick",
          track_code: "fyapp.b11932.c11933.d11937.click.FCWTClick",
          page: "车服首页",
          button_name: "券码快速展示"
        })
        break
    }
  },

  /**
   * 车服首页-地图找店顶部_点击_洗车页面点击
   * @param cityId 城市ID
   */
  trackHomeTopMapIconClick(cityId = "") {
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("FCWTClick", {
          requirement_id: 781,
          track_sign: "aCar.b2886.d2896.click.FCWTClick",
          track_code: "aCar.b2886.d2896.click.FCWTClick",
          page: "车服首页",
          button_name: "地图找店顶部",
          city_id: cityId
        })
        break
    }
  },

  /**
   * 车服首页-地图找店_点击_洗车页面点击
   * @param cityId 城市ID
   */
  trackHomeSearchFilterMapIconClick(cityId = "") {
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("FCWTClick", {
          requirement_id: 781,
          track_sign: "aCar.b2886.d2888.click.FCWTClick",
          track_code: "aCar.b2886.d2888.click.FCWTClick",
          page: "车服首页",
          button_name: "地图找店",
          city_id: cityId
        })
        break
    }
  },

  /**
   * 车服首页-Banner_点击_洗车页面点击
   * @param cityId 城市ID
   * @param vehicleId 车辆id
   * @param modelType 车型
   * @param servicePackageType 车辆服务权益类型 (有包,无包)
   * @param grantType 权限类型
   * @param bannerTitleName 车服banner标题
   */
  trackHomeBannerClick(cityId, vehicleId, modelType, servicePackageType, grantType, bannerTitleName) {
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("FCWTClick", {
          requirement_id: 781,
          track_sign: "aCar.b2886.d2887.click.FCWTClick",
          track_code: "aCar.b2886.d2887.click.FCWTClick",
          page: "车服首页",
          city_id: cityId,
          vehicle_service_package_type: servicePackageType,
          module_name: "Banner位",
          vehicle_id: vehicleId,
          model_type: modelType,
          grant_type: grantType,
          carwash_banner_title_name: bannerTitleName
        })
        break
      case BrandEnum.alps:
        sensors.track("FCWTClick", {
          requirement_id: 10846,
          track_sign: "alps.b4003.c11923.click.FCWTClick",
          track_code: "alps.b4003.c11923.click.FCWTClick",
          page: "车服首页",
          city_id: cityId,
          vehicle_service_package_type: servicePackageType,
          module_name: "Banner位",
          vehicle_id: vehicleId,
          model_type: modelType,
          grant_type: grantType,
          carwash_banner_title_name: bannerTitleName
        })
        break
      case BrandEnum.fy:
          sensors.track("FCWTClick", {
            requirement_id: 10850,
            track_sign: "fyapp.b11932.c11933.d11934.click.FCWTClick",
            track_code: "fyapp.b11932.c11933.d11934.click.FCWTClick",
            page: "车服首页",
            city_id: cityId,
            vehicle_service_package_type: servicePackageType,
            module_name: "Banner位",
            vehicle_id: vehicleId,
            model_type: modelType,
            grant_type: grantType,
            carwash_banner_title_name: bannerTitleName
          })
          break
    }
  },

  // 爱车-车服首页-上门洗车点击
  trackHomeMobileCarWashClick() {
    switch (currentBrand()) {
      case BrandEnum.nio:
        sensors.track("FCWTClick", {
          requirement_id: 1767,
          track_sign: "aCar.b2886.d4061.click.FCWTClick",
          track_code: "aCar.b2886.d4061.click.FCWTClick",
          page: "车服首页",
          button_name: "上门洗车按钮"
        })
        break
    }
  },

  /**
   * 车服商户详情页_页面浏览_车服洗车页面浏览
   * @param cityId 城市ID
   * @param shopId 店铺ID
   * @param vehicleId 车辆id
   * @param modelType 车型
   * @param vehicleServicePackageType 车辆服务权益类型：有包，无包
   */
  trackMerchantDetailPageView(
    cityId,
    shopId,
    vehicleId,
    modelType = "",
    vehicleServicePackageType = ""
  ) {
    const common = {
      page: "车服商户详情页",
      city_id: cityId,
      shop_id: shopId,
      vehicle_id: vehicleId,
      model_type: modelType,
      vehicle_service_package_type: vehicleServicePackageType,
    };
    switch (currentBrand()) {
      case BrandEnum.fy:
        common.requirement_id = 10850;
        common.track_sign = "fyapp.b11932.c12038.pageview.FCWTView";
        common.track_code = "fyapp.b11932.c12038.pageview.FCWTView";
        sensors.track("FCWTView", common)
        break
    }
  },

}

export default dataTrack
